if (!customElements.get('product-swatch')) {
    customElements.define('product-swatch', class ProductModel extends DeferredMedia {
      constructor() {
        super();
        this.title = this.getAttribute('data-title');

        if (!this.title) {
          console.error('Product Swatch requires a data-title attribute');
          return;
        }

        this.loadContent();
      }
  
      async loadData() {
        return await $.ajax({
            method: "POST",
            url: `https://${Shopify.shop}/api/2024-10/graphql.json`,
            contentType: "application/json",
            headers: {
              'X-Shopify-Storefront-Access-Token': `f012a86c4dec7f6f1ad27fcc1a61d021`,
              'Content-Type': 'application/graphql'
            },
            data:             `
                query {
                    search(query: "title:${this.title}", first: 50, types: PRODUCT) {
                        edges {
                            node {
                                ... on Product {
                                    id
                                    title
                                    options(first: 2) {
                                        name
                                        optionValues {
                                            name
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            `,
        });
      }
  
     loadContent(errors) {
        this.loadData().then(data => {
            const products = data.data.search.edges;
            let html = ``;
            let htmlCount = ``;
            let count = 0;
            products.forEach(element => {
                const p = element.node;
                const colors = p.options.filter(o => o.name === "Color");
                if(colors.length === 0) return;
                const color = colors[0].optionValues;
                const firstLetter = p.title.split(" ")[0];
                const fileUrl = `https://cdn.shopify.com/s/files/1/0514/2858/9720/files/color-${color[0].name.split(" ").join("-").toLowerCase().replace('["', '').replace('"]', '')}-${firstLetter.toLowerCase()}.png?width=20`;
                count ++;

                if(count < 6) {
                    html += `
                        <img src="${fileUrl}" loading="lazy" width="20" height="20"/>
                    `;
                }

            });

            const swatchHtml = `
                 <div class="variants-options">
                   ${html}
                   ${count >= 6 ? `<span class="plus-swatch">+${count - 5}</span>` : ''}
                 </div>
            `;

            this.innerHTML = swatchHtml;
        });
      }
    });
  }